const {debounce} = require('./util/debounce');

export default () => jQuery(($) => {

	$('.block--sticky').each(function () {
		// ignore items that are already wrapped
		if ($(this).parent('.blocks--sticky').length) {
			return;
		}
		let wrapper = $('<div class="blocks--sticky"/>');
		let next = $(this).next('.block--sticky');

		while (next.length) {
			let newnext = next.next('.block--sticky');
			wrapper.append(next);
			next = newnext;
		}
		$(this).after(wrapper);
		$(this).prependTo(wrapper);
	});

	// We don't want to apply sticky styling to elements that are taller than the viewport
	const stickyTest = debounce(function () {
		$('.block--sticky').each(function () {
			if ($(this).height() > $(window).height()) {
				$(this).removeClass('block--sticky-enabled');
			} else {
				$(this).addClass('block--sticky-enabled');
			}
		});
	}, 400);
	stickyTest();
	$(window).load(function () {
		stickyTest();
	});
	$(window).resize(function () {
		stickyTest();
	});
	const MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	const config = {
		attributes: true,
		childList: true,
		characterData: true,
		subtree: true,
	};
	const observer = new MutationObserver(function (mutations) {
		stickyTest();
	});
	$('.block--sticky').each(function () {
		observer.observe($(this)[0], config);
	});
});
